// periods.js — date-range helpers for Analytics v2's period picker.
// Ranges are half-open [start, end). Weeks start MONDAY (business week).

function addDays(d, n) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
}

export const PERIODS = [
  { key: "thisWeek", label: "This week" },
  { key: "lastWeek", label: "Last week" },
  { key: "thisMonth", label: "This month" },
  { key: "lastMonth", label: "Last month" },
  { key: "thisYear", label: "This year" },
  { key: "lastYear", label: "Last year" },
  { key: "all", label: "All time" },
];

export function periodRange(key, now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const monday = addDays(today, -((today.getDay() + 6) % 7));
  const y = today.getFullYear();
  const m = today.getMonth();
  switch (key) {
    case "thisWeek": return [monday, addDays(monday, 7)];
    case "lastWeek": return [addDays(monday, -7), monday];
    case "thisMonth": return [new Date(y, m, 1), new Date(y, m + 1, 1)];
    case "lastMonth": return [new Date(y, m - 1, 1), new Date(y, m, 1)];
    case "thisYear": return [new Date(y, 0, 1), new Date(y + 1, 0, 1)];
    case "lastYear": return [new Date(y - 1, 0, 1), new Date(y, 0, 1)];
    case "all":
    default: return [new Date(2000, 0, 1), addDays(today, 1)];
  }
}

export function formatRange([start, end]) {
  const opts = { month: "short", day: "numeric", year: "numeric" };
  const lastDay = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 1);
  return `${start.toLocaleDateString("en-CA", opts)} – ${lastDay.toLocaleDateString("en-CA", opts)}`;
}
